import { OriginalSitePrimaryContact } from '../interfaces/workflow.interface';

export const createLabelValueText = (label: string, value: string) => ({
  text: [{ text: `${label}:`, bold: true }, ` ${value}`],
});

export const getOriginalContactInfo = (
  primaryContactId: number | undefined,
  originalContact: OriginalSitePrimaryContact | null | undefined,
  fontSize = 16,
): any[] => {
  if (primaryContactId !== originalContact?.id && originalContact) {
    return [
      { text: 'Original Contact Information', fontSize },
      `${originalContact.firstName} ${originalContact.lastName}`,
      originalContact.email,
    ];
  }
  return [];
};
